import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=3630160f&scoped=true&"
import script from "./appoint.vue?vue&type=script&lang=js&"
export * from "./appoint.vue?vue&type=script&lang=js&"
import style0 from "./appoint.vue?vue&type=style&index=0&id=3630160f&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630160f",
  null
  
)

export default component.exports